import moment from 'moment-timezone'
import { formats } from '~/const/global'

export default superclass => class extends superclass {
  getDate (date) {
    return this.$moment(date).format(formats.date)
  }

  getTime (time) {
    return this.$moment(time).format(formats.time)
  }

  getDateTime (datetime) {
    if (!datetime) { return null }
    return this.$moment(datetime).format(formats.dateTime)
  }

  getDateTimeProcessing (datetime) {
    if (!datetime) { return null }
    // TODO Временное решение
    const date = new Date(datetime)
    const winterTime = new Date('2022-03-27T02:59:59+02:00')
    const offset = date.getTime() > winterTime.getTime() ? moment().tz('Europe/Kiev').utcOffset() : 120
    date.setHours(date.getHours() + offset / 60)
    return this.$moment(date).format(formats.dateTime)
  }
}
